import { render, staticRenderFns } from "./Undertaking.vue?vue&type=template&id=db71f1b2&scoped=true&"
import script from "./Undertaking.vue?vue&type=script&lang=js&"
export * from "./Undertaking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db71f1b2",
  null
  
)

export default component.exports